/* eslint-disable no-case-declarations */
/* eslint-disable semi */
import {
  LOADING,
  RESULT,
  LIST,
  INIT_CREATE,
  CREATE,
  READ,
  UPDATE,
  DELETE,
  STOCK_UPDATE,
  LIST_VM,
  LIST_BALANCE,
  TOGGLE_REFUND,
  MANUAL_UPDATE,
  ADD_PROJECT_HANDLE,
  TOGGLER_MULTI_BALANCE,
  POST_CONFIG_DOWNLOAD,
  CONFIG_DOWNLOAD,
} from "./actionTypes";

const INIT_STATE = {
  loading: true,
};

const Map = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESULT:
      const newState = {
        ...state,
        loading: false,
      };
      switch (action.payload.actionType) {
        case LIST:
          newState["list"] = action.payload.result;
          break;
        case MANUAL_UPDATE:
          newState["manualUpdate"] = action.payload.result;
          break;
        case ADD_PROJECT_HANDLE:
          newState["addProjectHandle"] = action.payload.result;
          break;
        case LIST_BALANCE:
          newState["list_balance"] = action.payload.result;
          break;
        case LIST_VM:
          newState["list_vm"] = action.payload.result;
          break;
        case INIT_CREATE:
          newState["initCreate"] = action.payload.result;
          break;
        case CREATE:
          newState["create"] = action.payload.result;
          break;
        case READ:
          newState["read"] = action.payload.result;
          break;
        case UPDATE:
          newState["update"] = action.payload.result;
          break;
        case STOCK_UPDATE:
          newState["stockUpdate"] = action.payload.result;
          break;
        case DELETE:
          newState["delete"] = action.payload.result;
          break;
        case TOGGLE_REFUND:
          newState["toggleRefund"] = action.payload.result;
          break;
        case TOGGLER_MULTI_BALANCE:
          newState["toggleMultiBalance"] = action.payload.result;
          break;
        case POST_CONFIG_DOWNLOAD:
          newState["setDownloadConfig"] = action.payload.result;
          break;
        case CONFIG_DOWNLOAD:
          newState["getDownloadConfig"] = action.payload.result;
          break;
      }
      return newState;

    default:
      return state;
  }
};

export default Map;
